import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import Masonry from 'react-masonry-css'
import { useStyles } from '../../style'
import TemplateImage from '../TemplateImage'
import BasePage from '../../../components/BasePage'
import { useConversationContext } from '../../../../stores/conversation.store'
import { MenuPage } from '../../../../stores/functionMenu.store'
import AnimatedSection from '../../../components/AnimatedSection'
import ChatInput from '../../../ChatPage/components/input'

interface ImageItem {
  id: string
  prompt: string
  path: string
}

const ImageGenLandingView: React.FC = () => {
  const { styles } = useStyles()
  const navigate = useNavigate()
  const [inputContent, setInputContent] = useState('')
  const [templateImages, setTemplateImages] = useState<ImageItem[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const { createConversation } = useConversationContext()
  const containerRef = useRef<HTMLDivElement>(null)

  // 加载创意模板图片
  useEffect(() => {
    fetch(import.meta.env.VITE_BASE_PATH + '/genImages/desc.json')
      .then((res) => res.json())
      .then((data: ImageItem[]) => {
        setTemplateImages(data)
      })
      .catch((error) => {
        console.error('加载创意模板失败:', error)
      })
  }, [])

  // 响应式布局配置
  const breakpointColumns = {
    default: 4,
    1400: 3,
    1100: 2,
    700: 1,
  }

  const handleUseTemplate = (prompt: string) => {
    setInputContent(prompt)
  }

  const handleCreateConversation = (prompt: string) => {
    if (!prompt.trim()) return
    setIsLoading(true)
    try {
      const newConversation = createConversation(MenuPage.ImageGen, prompt)
      navigate(
        `/img_chat/${newConversation.conversationId
        }?prompt=${encodeURIComponent(prompt)}`
      )
    } catch (error) {
      console.error('创建图像生成会话错误:', error)
      setIsLoading(false)
    }
  }

  return (
    <BasePage title="AI 图像生成">
      <div className={styles.container} ref={containerRef}>
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '48px',
            backgroundColor: 'white',
            zIndex: 5,
          }}
        ></div>
        <div
          style={{
            fontSize: '28px',
            color: ' #212329',
            lineHeight: '24px',
            textAlign: 'center',
            fontWeight: 'bold',
            margin: '100px 0 16px',
          }}
        >
          图像生成
        </div>
        <div
          style={{
            fontSize: '15px',
            color: ' #212329',
            lineHeight: '24px',
            textAlign: 'center',
            marginBottom: '24px',
          }}
        >
          重点风格包括但不限于水彩、油画、中国画、素描、扁平插画、二次元、3D卡通，搜集灵感，使用创意
        </div>
        <ChatInput
          inputValue={inputContent}
          onInputChange={setInputContent}
          onSubmit={handleCreateConversation}
          isLoading={isLoading}
          isImage={true}
          placeholder="您可以描述您所想象的画面，角色，情绪，场景，风格..."
        />

        <div className={styles.article}>
          <h2 style={{ margin: '0 0 16px', color: '#212329' }}>创意灵感</h2>
          <Masonry
            breakpointCols={breakpointColumns}
            className={styles.masonryGrid}
            columnClassName={styles.masonryColumn}
          >
            {[...templateImages].map((image, index) => (
              <AnimatedSection delay={0.1 * index} key={image.id}>
                <TemplateImage
                  key={image.id}
                  id={image.id}
                  path={image.path}
                  prompt={image.prompt}
                  onUseCreative={handleUseTemplate}
                />
              </AnimatedSection>
            ))}
          </Masonry>
        </div>
      </div>
    </BasePage>
  )
}

export default ImageGenLandingView
